import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_INDUSTRY_CATEGORIES } from '../actionConstants';

export const getAllIndustryCategoriesAction = createAction(
  GET_DICTIONARIES_INDUSTRY_CATEGORIES
);
